import { render } from "./DashboardChartsSection.vue?vue&type=template&id=4ab4cfb4&scoped=true"
import script from "./DashboardChartsSection.vue?vue&type=script&lang=js"
export * from "./DashboardChartsSection.vue?vue&type=script&lang=js"

import "./DashboardChartsSection.vue?vue&type=style&index=0&id=4ab4cfb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab4cfb4"]])

export default __exports__